import { Pessoa } from './Pessoa.js';

export class Cliente {
  constructor() {
    this.id = 0;
    this.pessoaId = 0;
    this.pessoa = new Pessoa();
    this.dataCad = new Date().toISOString();
    this.urlApi = '';
  }
}
